export async function userTradeLogin(formData) {
  const rsp = await fetch("/api/v1/trade_login", {
    method: "POST",
    body: formData,
  });
  return rsp.json();
}
